export const mod = (n: number, m: number): number => ((n % m) + m) % m;
